<!-- <mat-card>
    <div class="row">
        <div class="title">{{zone.name | uppercase}}</div>
        <div>
            <button  *ngIf="showEdit" mat-button mat-icon-button onclick="this.blur()" (click)="editZone()">
                <mat-icon>edit</mat-icon>
            </button>
            <button *ngIf="showArrow" mat-button mat-icon-button onclick="this.blur()" (click)="viewZone()">
                <mat-icon>arrow_forward</mat-icon>
            </button>
        </div>
        
    </div>
    <div class="gateway-status" *ngIf="zone.online !== undefined; else notAvailable">
        <div class="flex items-center">
            <div class="indicator" [ngClass]="zone.online ? 'online' : 'offline'"></div>
            Gateway status: {{zone.online ? 'online' : 'offline'}}
        </div>
    </div>
    <ng-template #notAvailable>
        Gateway status: not available
    </ng-template>
    <div class="gateway-id" *ngIf="zone.gateway">
        Gateway id: {{zone.gateway}}
    </div>
    <div class="day-week-count" *ngIf="zone.activeCycle">
        <span>Current state: {{zone.activeCycle.currentState.state}} | </span> <b>Week {{growCycleCount.week}} Day
            {{growCycleCount.day}}</b>
        <hr>
    </div>

    <ng-container *ngFor="let category of zone.reducedSensors">
        <div class="category-header">
            {{categories[category.kind] | uppercase}}
        </div>
        <ng-container *ngFor="let sensor of category.values">
            <div class="sensor-type-header">
                <span class="name">{{sensor.type | sensorDisplayName}}</span>
                <span class="type-format">{{sensor.type | sensorFormat}}</span>
            </div>

            <div class="values-container">
                <div class="value-container" *ngFor="let item of sensor.values"
                     (click)="onPointClick($event, item, sensor.type)">
                    <div class="value-box"
                         [ngClass]="{'error' : isOffRange(item.value && item.value[0], sensor.type)}">
                        {{item.value && item.value[0] | sensorValue:sensor.type | number:'0.0-2' }}</div>
                    <div class="sensor-name" [matTooltip]="item.sensorName">{{item.sensorName}}</div>
                </div>
            </div>
        </ng-container>

    </ng-container>

</mat-card> -->

<mat-card>
    <mat-card-header>
        <mat-card-title>
            <div class="row">
                <div class="title">{{zone.name | uppercase}}</div>
                <div class="title">
                    <button  *ngIf="authService.isSuperAdmin && showEdit" mat-button mat-icon-button onclick="this.blur()" (click)="editZone()">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button *ngIf="authService.isSuperAdmin && showEdit" mat-button mat-icon-button onclick="this.blur()" (click)="deleteZone(zone)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button *ngIf="showArrow" mat-button mat-icon-button onclick="this.blur()" (click)="viewZone()">
                        <mat-icon>arrow_forward</mat-icon>
                    </button>
                    
                </div>
            </div> 
        </mat-card-title>
       
        <mat-card-subtitle>
            <div class="gateway-status" *ngIf="zone.online !== undefined; else notAvailable">
                <div class="flex items-center">
                    <div class="indicator" [ngClass]="zone.online ? 'online' : 'offline'"></div>
                    Gateway status: {{zone.online ? 'online' : 'offline'}}
                </div>
            </div>
            <ng-template #notAvailable>
                Gateway status: not available 
            </ng-template>
            <div class="gateway-id" *ngIf="zone.gateway">
                Gateway id: {{zone.gateway}}
            </div>
            <!-- <div class="day-week-count" *ngIf="zone.activeCycle">
                <span>Current state: {{zone.activeCycle.currentState.state}} | </span> <b>Week {{growCycleCount.week}} Day
                    {{growCycleCount.day}}</b>
                <hr>
            </div> -->
        </mat-card-subtitle>
       
    </mat-card-header>
   
</mat-card>
<mat-accordion *ngIf="zone.reducedSensors.length"  >
    <mat-expansion-panel [hideToggle]="!zone.reducedSensors.length" class="line" (opened)="zoneOpenState = true"
    (closed)="zoneOpenState = false"
    [ngStyle]="{'backgroundColor': zoneOpenState ? '#FFFFFF' : '#edf2f1' }">
      <mat-expansion-panel-header [collapsedHeight]="'30px'">
        <mat-panel-description *ngIf="zoneOpenState === false">Expand</mat-panel-description>
      </mat-expansion-panel-header>
      <mat-expansion-panel class="line" (opened)="categoryOpenState = true"
      (closed)="categoryOpenState = false"
      *ngFor="let category of zone.reducedSensors">
        <mat-expansion-panel-header [collapsedHeight]="'70px'">
            <mat-panel-title >
                <div class="category-header">
                    {{categories[category.kind] | uppercase}}
                </div>
            </mat-panel-title>
        <mat-panel-description>

        </mat-panel-description>
        </mat-expansion-panel-header>
            <ng-container *ngFor="let sensor of category.values">
                <div class="sensor-type-header">
                    <span class="name">{{sensor.type | sensorDisplayName}}</span>
                    <span class="type-format">{{sensor.type | sensorFormat}}</span>
                </div>

                <div class="values-container">
                    <div class="value-container" *ngFor="let item of sensor.values"
                    (click)="onPointClick($event, item, sensor.type)">
                        <div class="value-box"
                            [ngClass]="{'error' : isOffRange(item.value && item.value[0], sensor.type)}">
                            {{item.value && item.value[0] | sensorValue:sensor.type | number:'0.0-2' }}</div>
                        <div class="sensor-name" [matTooltip]="item.sensorName">{{item.sensorName}}</div>
                    </div>
                </div>
            </ng-container>
        </mat-expansion-panel>
    </mat-expansion-panel>
</mat-accordion>


